module.exports = __webpack_public_path__ + "d483cce9c778e6b36bc06b0565233516.svg";